import { render, staticRenderFns } from "./PhishingCatcherLayout.vue?vue&type=template&id=186112f0&scoped=true&"
import script from "./PhishingCatcherLayout.vue?vue&type=script&lang=js&"
export * from "./PhishingCatcherLayout.vue?vue&type=script&lang=js&"
import style0 from "./PhishingCatcherLayout.vue?vue&type=style&index=0&id=186112f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186112f0",
  null
  
)

export default component.exports